import { ConnectionNames } from "../../../Contracts";
import { getRequestProps } from "../../../Common";
export function BetSlipRequestFormatter(message) {
    let { baseUrl, endpoint, method, headers, body, params } = getRequestProps(ConnectionNames.betslip, message);
    headers["Content-Type"] = "application/json-patch+json";
    if (typeof params !== "undefined") {
        body = JSON.stringify(params);
    }
    return new Request(`${baseUrl}${endpoint}`, {
        method,
        headers,
        body
    });
}
//# sourceMappingURL=BetSlipRequestFormatter.js.map